import React from 'react'
import { PulseLoader as Loader } from 'react-spinners'
import { LOADER_COLOR } from '../../constants'
import './loader.scss'

export default () => (
  <div className="loader">
    <Loader color={LOADER_COLOR} />
  </div>
)
